// extracted by mini-css-extract-plugin
export var aiStarIcon = "_6i-4";
export var closeButton = "_6i-6";
export var dismissButton = "_6i-3";
export var editImageWithAiContainer = "_6i-8";
export var imageUploadWrapper = "_6i-7";
export var misspelledWord = "_6i-5";
export var spellCheckContainer = "_6i-2";
export var spin = "_6i-1";
export var spinning = "_6i-0";